import React from 'react'
import qs from 'query-string'
import isString from 'lodash.isstring'

import logo from '@images/logo-leaf.svg'
import salesforceLogo from '@images/salesforce-thrive-logo.svg'
import mastercardLogo from '@images/mastercard-logo.png'
import iconBars from '@images/icons/icon_bars.svg'
import iconSearch from '@images/icons/search.svg'

import {
  AltNav,
  AltNavInnerWrapper,
  AltNavLinkWrapper,
  LogoWrapper,
  MastercardLogo,
  Nav,
  NavInnerWrapperLeft,
  NavInnerWrapperRight,
  NavInnerWrapperCenter,
  SalesforceLogo,
  LanguageSwitcherWrapper,
} from './styles'
import { DesktopWrapper, MobileWrapper } from '../../SharedStyles'

import LanguageSwitcher from '@elements/LanguageSwitcher'
import { Wrapper } from '../../Layout/Grid'
import { GRID_BREAKPOINTS } from '@util/breakpoints'
import { Icon, IconSize } from '@thriveglobal/thrive-ui-lib'

const SALESFORCE_URL =
  'https://thriveacademy.touchcast.com/salesforce/thriving-mind'
const MASTERCARD_URL = 'https://thriveglobal.touchcast.com/academy/mastercard'

type Props = {
  toggleSidenav: Function
  links: any
}

const NavBar: React.FC<Props> = ({ toggleSidenav, links }) => {
  const StandardNav = (
    <Nav role="navigation">
      <Wrapper maxWidth={GRID_BREAKPOINTS.desktop}>
        <DesktopWrapper>
          <NavInnerWrapperLeft>
            <LogoWrapper href="/">
              <img src={logo} alt="Thrive logo desktop" />
            </LogoWrapper>
          </NavInnerWrapperLeft>
          <NavInnerWrapperRight>
            <LanguageSwitcherWrapper>
              <LanguageSwitcher />
            </LanguageSwitcherWrapper>
            <div>{links}</div>
          </NavInnerWrapperRight>
        </DesktopWrapper>
        <MobileWrapper>
          <NavInnerWrapperCenter>
            <Icon
              size={IconSize.xs}
              iconSrc={iconBars}
              onClick={() => toggleSidenav()}
            />
            <LogoWrapper href="/">
              <img src={logo} alt="Thrive logo mobile" />
            </LogoWrapper>
            <Icon size={IconSize.sm} iconSrc={iconSearch} />
          </NavInnerWrapperCenter>
        </MobileWrapper>
      </Wrapper>
    </Nav>
  )

  const AltNavSalesforce = (
    <AltNav role="navigation" background="#6dcbd2">
      <AltNavInnerWrapper>
        <LogoWrapper href="https://thriveglobal.com">
          <SalesforceLogo
            src={salesforceLogo}
            alt="Thrive and Salesforce logos"
          />
        </LogoWrapper>
        <AltNavLinkWrapper>{links}</AltNavLinkWrapper>
      </AltNavInnerWrapper>
    </AltNav>
  )

  const AltNavMastercard = (
    <AltNav role="navigation" background="#000">
      <AltNavInnerWrapper>
        <LogoWrapper>
          <MastercardLogo src={mastercardLogo} alt="Mastercard logo" />
        </LogoWrapper>
        <AltNavLinkWrapper>{links}</AltNavLinkWrapper>
      </AltNavInnerWrapper>
    </AltNav>
  )

  const parsed = qs.parse(window.location.search)
  const redirectUrl = isString(parsed?.redirect_url)
    ? decodeURIComponent(parsed.redirect_url)
    : ''

  switch (redirectUrl) {
    case SALESFORCE_URL:
      return AltNavSalesforce
    case MASTERCARD_URL:
      return AltNavMastercard
    default:
      return StandardNav
  }
}

export default NavBar
